
import { Course } from '../types';

export const non_molestation: Course = {
  id: "non_molestation",
  title: "Injunctions & Undertakings",
  description: "Navigate domestic abuse injunctions and protect your legal record.",
  icon: "🚫",
  totalModules: 14,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/non_molestation/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is a Non-Molestation Order (NMO) primarily designed to do?",
        "o": [
            "Determine who has the right to live in the family home.",
            "Protect a person from domestic abuse.",
            "Grant a divorce without court intervention.",
            "Provide financial support to family members."
        ],
        "a": 1
    },
    {
        "q": "According to the slides, what is a key characteristic of Ex-Parte Non-Molestation Orders (NMOs)?",
        "o": [
            "They always require both parties to be present for the initial decision.",
            "They can be granted 'Without Notice' in urgent situations.",
            "They only apply to financial disputes, not personal conduct.",
            "They are primarily used to establish child custody."
        ],
        "a": 1
    },
    {
        "q": "What is the maximum prison sentence mentioned for breaching a Non-Molestation Order?",
        "o": [
            "1 Year",
            "2 Years",
            "5 Years",
            "10 Years"
        ],
        "a": 2
    },
    {
        "q": "What does the slide state as the purpose of 'The Return Date' in an injunction case?",
        "o": [
            "It is the date the injunction automatically expires.",
            "It is the date when financial assets are divided between parties.",
            "It is your formal chance to present your side of the story and challenge false allegations.",
            "It is the date for the judge to make the initial Ex-Parte decision."
        ],
        "a": 2
    },
    {
        "q": "What is a primary benefit of offering an 'Undertaking Without Admissions' in court?",
        "o": [
            "It automatically grants full child contact rights.",
            "It requires the court to make formal findings of abuse.",
            "It allows you to admit to allegations while avoiding consequences.",
            "It resolves the case quickly while avoiding formal admission of allegations and keeps your legal record clear."
        ],
        "a": 3
    }
]
};
